module.exports = __webpack_public_path__ + "img/sld_mfm_ic_2_t1_dark.22ab25ed.svg";